import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  @Input() notes: any;
  constructor() { }
  public isToyotaTheme: boolean; 
  ngOnInit() {
    this.isToyotaTheme = environment.applicationName === 'toyota';
    
  }
}
